import IconUpload from "components/icons/icn-upload.icon";
import { useState } from "react";
import intl from "react-intl-universal";
import { useProductionPlanSupplierContext } from "../../context";
import ProductionPlanSupplierImportExport from "../production-plan-supplier-import-export";
import * as S from "./styled";

const ProductionPlanSupplierUpload = () => {
  const { searchProductionPlanData, filters } = useProductionPlanSupplierContext();
  const [openUpload, setOpenUpload] = useState(false);

  const close = async () => {
    await searchProductionPlanData(filters);
    setOpenUpload(false);
  };

  return (
    <S.UploadSectionWrapper>
      <S.UploadButton type="button" onClick={() => setOpenUpload(true)}>
        <S.UploadButtonIcon>
          <IconUpload width={24} height={24} color="var(--color-contrast-white)" />
        </S.UploadButtonIcon>
        {intl.get("productionPlanSupplier.upload")}
      </S.UploadButton>
      <ProductionPlanSupplierImportExport isOpen={openUpload} close={close} />
    </S.UploadSectionWrapper>
  );
};

export default ProductionPlanSupplierUpload;
